export const CASCADE_STATE_CHANGED = 'cascade-state-changed'

export function dispatchCascadeStateChanged(requestId?: string) {
  window.dispatchEvent(new CustomEvent(CASCADE_STATE_CHANGED, {
    detail: { requestId },
  }))
}

export function onCascadeStateChanged(handler: (requestId?: string) => void) {
  const listener = (e: Event) => {
    handler((e as CustomEvent).detail?.requestId)
  }
  window.addEventListener(CASCADE_STATE_CHANGED, listener)
  return () => window.removeEventListener(CASCADE_STATE_CHANGED, listener)
}
